import AuthSocial from "../components/AuthSocial";
import GroupPicker from "../components/GroupPicker";
import MenuNavigation from "../components/MenuNavigation";
import ModalDialog from "../components/ModalDialog";
import ModalPicker from "../components/ModalPicker";
import UserBox from "../components/UserBox";
import { apiGetIpConfig } from "../utils/api";
import { DEFAULT_COUNTRY } from "../utils/constant";
import { EVENTS, callEvent } from "../utils/event";
import { LocalStorage } from "./LocalStorage";
import { SettingConfig } from "./SettingConfig";

export class DCStatic {
  static _ipCountry;
  static _shippingTo;
  static _shippingCountry;
  static _currencies;
  static _currency;
  static _billingCountry;
  static _locale;
  static _phoneNumber;
  static _displayName;
  static _email;
  static _isMerchant;

  /** @type {AuthSocial} */
  static _authSocial;
  /** @type {ModalPicker} */
  static _modalPicker;
  static _modalPickerSetting;
  /** @type {GroupPicker} */
  static _groupPicker;
  static _groupPickerSetting = {};
  /** @type {UserBox} */
  static _userBox;
  static _userBoxSetting = {};
  /** @type {MenuNavigation} */
  static _menuNavigation;
  static _menuNavigationSetting = {};
  /** @type {ModalDialog} */
  static _modalDialog;

  static setUpIpConfig(setUpLang = () => { }, hidePopupSetting = false) {
    let countryCode = LocalStorage.getLocation(), isTimeOut = true;
    const MAX_CACHE_LOCATION = 72 * 60 * 60 * 1000;

    if (countryCode) {
      const arr = countryCode.split("|");
      if (arr.length === 2 && arr[0] && (Date.now() - arr[1]) < MAX_CACHE_LOCATION) {
        isTimeOut = false;
      }
    }
    let billing = LocalStorage.getBilling(), language = LocalStorage.getLanguage(),
      shipping = LocalStorage.getShipping(), shippingList = LocalStorage.getShippingList(),
      currency = LocalStorage.getCurrency(), currencyList = LocalStorage.getCurrencyList(),
      ipCountry = LocalStorage.getIpCountry();

    if (isTimeOut || !billing || !shipping || !currency || !language || !currencyList || !shippingList || !ipCountry) {
      apiGetIpConfig(
        (data) => {
          if (data) {
            let setting = SettingConfig.fromApiObject(data);
            DCStatic.handleSettingConfig(setting, hidePopupSetting);
          }
          typeof (setUpLang) === "function" && setUpLang();
          callEvent(EVENTS.CHANGE_SETTING);
        },
        () => {
          typeof (setUpLang) === "function" && setUpLang();
          callEvent(EVENTS.CHANGE_SETTING);
        }
      )
    } else {
      let sc = SettingConfig.getShipping(shipping, shippingList);
      let cur = SettingConfig.getCurrency(currency, currencyList, sc);
      sc !== shipping && LocalStorage.setShipping(sc);
      cur !== currency && LocalStorage.setCurrency(cur);
      typeof (setUpLang) === "function" && setUpLang();

      DCStatic.setSettingConfig({
        shippingCountry: sc,
        shippingTo: shippingList,
        currency: cur,
        currencies: currencyList,
        ipCountry: ipCountry,
        billingCountry: billing,
        locale: language,
      })
    }
  }

  /** @param {SettingConfig} setting */
  static handleSettingConfig(setting, hidePopupSetting) {
    let bill = (setting.billingCountry || DEFAULT_COUNTRY).toUpperCase();
    let sc = setting.getShipping();
    let cur = setting.getCurrency(sc);
    let countryCode = setting.ipCountry || DEFAULT_COUNTRY;

    if (LocalStorage.getIpCountry() !== countryCode) LocalStorage.setIpCountry(countryCode);
    if (LocalStorage.getBilling() !== bill) LocalStorage.setBilling(bill);
    if (LocalStorage.getShipping() !== sc) LocalStorage.setShipping(sc);
    if (LocalStorage.getCurrency() !== cur) LocalStorage.setCurrency(cur);
    LocalStorage.setCurrencyList(setting.currencies);
    LocalStorage.setShippingList(setting.shippingTo);
    LocalStorage.setLocation(countryCode + "|" + Date.now());

    this.setSettingConfig({
      shippingCountry: sc,
      shippingTo: setting.shippingTo,
      currency: cur,
      currencies: setting.currencies,
      ipCountry: countryCode,
      billingCountry: bill,
    })

    let langCur = SettingConfig.getLanguage();
    if (!hidePopupSetting && langCur && setting.locale !== langCur) {
      !LocalStorage.hasExtension() && !LocalStorage.isMiniApp() &&
        setTimeout(() => {
          DCStatic.groupPicker.onShow();
        }, 500);
    } else {
      if (LocalStorage.getLanguage() !== setting.locale) LocalStorage.setLanguage(setting.locale);
      DCStatic.locale = setting.locale;
    }
  }

  /** @param {SettingConfig} setting */
  static setSettingConfig(setting = {}) {
    if (setting.shippingCountry) DCStatic.shippingCountry = setting.shippingCountry;
    if (setting.shippingTo) DCStatic.shippingTo = setting.shippingTo;
    if (setting.currency) DCStatic.currency = setting.currency;
    if (setting.currencies) DCStatic.currencies = setting.currencies;
    if (setting.ipCountry) DCStatic.ipCountry = setting.ipCountry;
    if (setting.billingCountry) DCStatic.billingCountry = setting.billingCountry;
    if (setting.locale) DCStatic.locale = setting.locale;
  }

  static get ipCountry() {
    return DCStatic._ipCountry;
  }
  static set ipCountry(value) {
    DCStatic._ipCountry = value;
  }

  static get shippingTo() {
    return DCStatic._shippingTo;
  }
  static set shippingTo(value) {
    DCStatic._shippingTo = value;
  }

  static get shippingCountry() {
    return DCStatic._shippingCountry;
  }
  static set shippingCountry(value) {
    DCStatic._shippingCountry = value;
  }

  static get currencies() {
    return DCStatic._currencies;
  }
  static set currencies(value) {
    DCStatic._currencies = value;
  }

  static get currency() {
    return DCStatic._currency;
  }
  static set currency(value) {
    DCStatic._currency = value;
  }

  static get billingCountry() {
    return DCStatic._billingCountry;
  }
  static set billingCountry(value) {
    DCStatic._billingCountry = value;
  }

  static get locale() {
    return DCStatic._locale;
  }
  static set locale(value) {
    DCStatic._locale = value;
  }

  static get phoneNumber() {
    return DCStatic._phoneNumber;
  }
  static set phoneNumber(value) {
    DCStatic._phoneNumber = value;
  }

  static get displayName() {
    return DCStatic._displayName;
  }
  static set displayName(value) {
    DCStatic._displayName = value;
  }

  static get email() {
    return DCStatic._email;
  }
  static set email(value) {
    DCStatic._email = value;
  }

  static get isMerchant() {
    return DCStatic._isMerchant;
  }
  static set isMerchant(value) {
    DCStatic._isMerchant = value;

    if (DCStatic._authSocial) {
      DCStatic._authSocial.setIsMerchant(value);
    }
  }

  static get authSocial() {
    if (!DCStatic._authSocial) {
      DCStatic._authSocial = new AuthSocial({ parent: ".main-page", isMerchant: DCStatic.isMerchant });
    }
    return DCStatic._authSocial;
  }
  static set authSocial(value) {
    DCStatic._authSocial = value;
  }

  static get modalPicker() {
    if (!DCStatic._modalPicker) {
      DCStatic._modalPicker = new ModalPicker({
        parent: ".main-page",
        ...DCStatic._modalPickerSetting,
        curLanguage: DCStatic.locale,
        curShipping: DCStatic.shippingCountry,
        curCurrency: DCStatic.currency,
        shippingList: DCStatic.shippingTo,
        currencyList: DCStatic.currencies,
      });
    }
    return DCStatic._modalPicker;
  }
  static set modalPicker(value) {
    DCStatic._modalPicker = value;
  }
  static get modalPickerSetting() {
    return DCStatic._modalPickerSetting;
  }
  static set modalPickerSetting(value) {
    DCStatic._modalPickerSetting = value;
  }

  static get groupPicker() {
    if (!DCStatic._groupPicker) {
      DCStatic._groupPicker = new GroupPicker({
        parent: ".main-page",
        ...DCStatic._groupPickerSetting,
        curLanguage: this.locale,
        curShipping: this.shippingCountry,
        curCurrency: this.currency,
      });
    }
    return DCStatic._groupPicker;
  }
  static set groupPicker(value) {
    DCStatic._groupPicker = value;
  }
  static get groupPickerSetting() {
    return DCStatic._groupPickerSetting;
  }
  static set groupPickerSetting(value) {
    DCStatic._groupPickerSetting = value;
  }

  static get userBox() {
    if (!DCStatic._userBox) {
      DCStatic._userBox = new UserBox({ parent: ".main-page", ...DCStatic._userBoxSetting });
    }
    return DCStatic._userBox;
  }
  static set userBox(value) {
    DCStatic._userBox = value;
  }
  static get userBoxSetting() {
    return DCStatic._userBoxSetting;
  }
  static set userBoxSetting(value) {
    DCStatic._userBoxSetting = value;
  }

  static get menuNavigation() {
    if (!DCStatic._menuNavigation) {
      DCStatic._menuNavigation = new MenuNavigation({ parent: ".main-page", ...DCStatic._menuNavigationSetting });
    }
    return DCStatic._menuNavigation;
  }
  static set menuNavigation(value) {
    DCStatic._menuNavigation = value;
  }

  static get menuNavigationSetting() {
    return DCStatic._menuNavigationSetting;
  }
  static set menuNavigationSetting(value) {
    DCStatic._menuNavigationSetting = value;
  }

  static get modalDialog() {
    if (!DCStatic._modalDialog) {
      DCStatic._modalDialog = new ModalDialog({ parent: ".main-page" });
    }
    return DCStatic._modalDialog;
  }
  static set modalDialog(value) {
    DCStatic._modalDialog = value;
  }
}